// Release dialog option templates shared by listen and edit dialog selects.
import { HIDE_DURATION_MONTHS_MAX } from '../../../shared/config/constants'
import { t } from '../../../shared/config/translations'

/** Renders hide-duration select options for release listen/edit dialogs. */
export function hideDurationOptionsTemplate(
	selectedMonths: number | 'forever' | null,
	options?: { foreverValue?: string },
): string {
	const foreverValue = options?.foreverValue ?? 'forever'

	return [
		`<option value="" ${selectedMonths ? '' : 'selected'}>${t('release.hidePlaceholder')}</option>`,
		`<option value="${foreverValue}" ${selectedMonths === 'forever' ? 'selected' : ''}>${t('release.hideForever')}</option>`,
		...Array.from({ length: HIDE_DURATION_MONTHS_MAX }, (_, idx) => {
			const months = idx + 1
			const selected = selectedMonths === months ? 'selected' : ''
			const label = `${months} month${months > 1 ? 's' : ''}`
			return `<option value="${months}" ${selected}>${label}</option>`
		}),
	].join('')
}
